// ANGULAR DEPENDENCY
import { NgModule } from '@angular/core';

// NGRX
import { EffectsModule } from '@ngrx/effects';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';

// STORE REDUCER AND EFFECTS
import { TimesheetEffects } from './store/effects';
import * as fromTimesheet from './store/reducer';

// SERVICES
import { TimesheetService } from './services/timesheet.service';
import { TimesheetStoreService } from './timesheet-store.service';


/**
 * Local storage sync function for sync store state keys with local storage
 */
export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({ keys: ['timesheet'], rehydrate: true })(reducer);
}

// add localstorage function in meta reducers
const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];

/**
 * This module is for configure timesheet ngrx related stuff.
 *
 *   @author Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>
 * Notes:-
 * Date: 28-05-2020 TimeSheet store module created
 */
@NgModule({
  imports: [
    StoreModule.forFeature('timesheet', fromTimesheet.reducer, { metaReducers }),
    EffectsModule.forFeature([TimesheetEffects]),
  ],
  declarations: [],
  providers: [
    TimesheetService,
    TimesheetStoreService,
  ],
})
export class TimeSheetStoreModule { }
